import HorizontalDivider from "plos/src/components/HorizontalDivider";
import Subheading from "plos/src/components/Subheading";
import { useTranslation } from "react-i18next";
import { leagueTypeStyles } from "../leagueType.css";
import { leagueTypePlaceholderOuter } from "./leagueTypePlaceholder.css";

const LeagueTypePlaceholder = ({ title }: { title: string }) => {
  const { t } = useTranslation("leaguesAndCups");
  return (
    <div className={leagueTypePlaceholderOuter}>
      <div className={leagueTypeStyles}>
        <Subheading>{title}</Subheading>
        <p>
          {t("leagueTypePlaceholder.noJoinedYet", "No {{title}} joined yet.", {
            title: title.toLowerCase(),
          })}
        </p>
      </div>
      <HorizontalDivider />
    </div>
  );
};
export default LeagueTypePlaceholder;
